import { render, staticRenderFns } from "./VDayDate.vue?vue&type=template&id=842a2b82"
import script from "./VDayDate.vue?vue&type=script&lang=js"
export * from "./VDayDate.vue?vue&type=script&lang=js"
import style0 from "./VDayDate.vue?vue&type=style&index=0&id=842a2b82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports